import React, { useEffect } from "react";
import "./About.css";
import passportImg from "../images/prm1.jpeg";

function About() {
  useEffect(() => {
    document.title = "Pijush Ray Mondal || About";
    const hiddenElement = document.querySelectorAll(".hidden");
    // console.log(hiddenElement);
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        // console.log(e);
        if (e.isIntersecting) {
          e.target.classList.add("show");
        } else {
          e.target.classList.remove("show");
        }
      });
    });

    hiddenElement.forEach((el) => {
      observer.observe(el);
      // console.log(el);
    });
  }, []);
  return (
    <div className="about">
      <div className="who-pijush">
        <h2>About</h2>
        <h1>Who Is Pijush?</h1>
      </div>
      <div className="pijush-deatils">
        <div className="pic-myself">
          <figure>
            <img src={passportImg} alt="img-pijush" />
          </figure>
        </div>
        <div className="details-myself">
          <p className="deatils-title hidden">
            A curiosity-driven Front-End Developer with design chops.
          </p>
          <p className="deatils-about hidden">
            I'm passionate about bringing both the technical and visual aspects
            of digital products to life. User experience, beautiful pixels and
            writing clean accessible, human code matters to me. I sweat the
            details.
            {/* And as a follower of John Maeda’s
            <a href="http://lawsofsimplicity.com/">Laws Of Simplicity</a> , I
            agree that less is more. */}
          </p>
          <p className="deatils-about hidden">
            I have a B.TECH in Computer Science Engineering from{" "}
            <a href="http://makautexam.net/">
              Maulana Abul Kalam Azad University of Technology
            </a>
            , formerly known as West Bengal University of Technology, a
            Certificate of Web Development Immersive from Udemy Platform ,
            instractor of{" "}
            <a href="https://www.udemy.com/share/101Wfe3@Xvxati08luZHmMrJgr-64XJt3Mb5qn8R1vpsMRWNlU_muHEEpK1BtHXz2le2ONrLhw==/">
              {" "}
              jonas schmedtmann.
            </a>
          </p>{" "}
          <p className="deatils-about hidden">
            I'm happiest when I'm creating, learning, exploring and thinking
            about how to make things better.I'm not available for any freelance
            work, but feel free to reach out and say hello! I promise I don't
            bite 😉
          </p>
        </div>
      </div>
    </div>
  );
}

export default About;
